<p class="modalDescription">{{ description }}</p>
<ul [formGroup]="formGroup">
  @if (requiredDocs.cgu) {
  <li>
    <label class="custom-checkbox-field">
      <input type="checkbox" formControlName="checkbox1" />
      <div class="material-icons checkbox-option-state"></div>
      <span class="ps-2 font-size-16"
        >{{ 'modal_condition_utilisation.accept_text_1' | translate }}
        <a [routerLink]="['/cgu']" target="_blank" class="link">{{
          'modal_condition_utilisation.link_cgu' | translate
        }}</a>
        (CGU).
      </span>
    </label>
  </li>
  } @if (requiredDocs.cggc) {
  <li>
    <label class="custom-checkbox-field">
      <input type="checkbox" formControlName="checkbox2" />
      <div class="material-icons checkbox-option-state"></div>
      <span class="ps-2 font-size-16"
        >{{ 'modal_condition_utilisation.accept_text_1' | translate }}
        <a [routerLink]="['/cggc']" target="_blank">
          {{ 'modal_condition_utilisation.link_cggc' | translate }}
        </a>
        (CGGC).
      </span>
    </label>
  </li>
  } @if (requiredDocs.pc) {
  <li>
    <label class="custom-checkbox-field">
      <input type="checkbox" formControlName="checkbox3" />
      <div class="material-icons checkbox-option-state"></div>
      <span class="ps-2 font-size-16">
        {{ 'modal_condition_utilisation.accept_text_2' | translate }}
        <a [routerLink]="['/politique-de-confidentialite']" target="_blank" class="link">{{
          'modal_condition_utilisation.link_privacy' | translate
        }}</a>
        {{ 'modal_condition_utilisation.accept_text_3' | translate }}
      </span>
    </label>
  </li>
  }
</ul>

@if (hasAnyDocToValidate) {
<div class="row justify-content-center">
  <div class="col-3">
    <lib-button
      [text]="labelCancel"
      (onClick)="onClose()"
      backgroundColor="white"
      [borderSize]="0"
      color="primary"
    />
  </div>
  <div class="col-4">
    <lib-button
      [text]="labelConfirm"
      (onClick)="confirm()"
      backgroundColor="primary"
      [disabled]="!formGroup.valid"
    />
  </div>
</div>
}
